
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'

import vCityPick from '../../components/cityPicker';
import api from '../../api';

export default {

beforeRouteEnter: (to, from, next) => {
next((vm) => {
});
},
components: {
Group,
XButton,
vCityPick,
PopupPicker,
},
mounted() {
this.getContact();
},
watch: {
start(val) {
if (val[1] === '0') {
this.formData.start = val[0];
} else {
this.formData.start = val[1];
}
},
end(val) {
if (val[1] === '0') {
this.formData.end = val[0];
} else {
this.formData.end = val[1];
}
},
contactId(val) {
this.formData.contactId = val[0];
},
},
data() {
return {
start: [],
end: [],
contactId: [],
formData: {
start: '',

contactId: '',
},
contactList: [],
};
},
computed: {
},
methods: {
save() {
const { start, end, contactId } = this.formData;
if (start === '' || end === '' || contactId === '') {
this.$vux.toast.text('请完善信息');
} else {
this.formData.type = 3;
api.vega.company.updateCompanyLine(this.formData).then((res) => {
console.log(res);
const code = res.data;
if (code.code === 0 && code.sub_code === 0) {
this.$vux.toast.text('保存成功');
this.$router.go(-1);
}
})
}
},
startCharge(val) {
this.start = val;
},
endCharge(val) {
this.end = val;
},
getContact() {
api.vega.contact.listContacts({
pageNo: 1,
pageSize: 100,
}).then((res) => {
const data = res.data.data.result;
if (data.length === 0) {
this.$vux.toast.text('当前没有联系人信息, 请先添加');
} else {
data.map((item) => {
item.value = `${item.id}`;
return item;
});
this.contactList = [data];
}
});
},
},
};
